import { NavLink } from 'react-router-dom';
import { Menu, Bell } from 'react-feather';
import UserDropdown from './UserDropdown';
import Logo from '../../../assets/images/ist-logo.png';

const Navbar = (props) => {
  const { setMenuVisibility, items } = props;

  return (
    <>
      <div className="navbar-nav d-md-none my-auto m-2" onClick={() => setMenuVisibility(true)}>
        <Menu className="ficon" />
      </div>
      <div className="d-none d-md-block my-auto m-1">
        <img src={Logo} alt="logo" width="120" />
      </div>

      <ul className="nav navbar-nav align-items-center ms-auto">
        <ul className="nav navbar-nav align-items-center ms-auto mx-3 d-none d-md-inline-flex">
          {items.map((item, i) => (
            <li key={i} className="nav-item mx-1">
              <NavLink className="nav-link" to={item.path}>
                {item.title}
              </NavLink>
            </li>
          ))}
        </ul>

        <Bell size={21} />
        <UserDropdown />
      </ul>
    </>
  );
};

export default Navbar;
